export default __webpack_public_path__ + "static/media/download.b02f99e2.svg";